<template>
  <div class="fotterAll">
    <div class="fotterTop">
      <div class="fotterDetail">
        <div class="txt_a_l">
          <div class="fotterDetail_list_1">
            <div class="fotterDetail_list_img">
              <img src="../../static/fotter_1.png" />
            </div>
            <div class="fotterDetail_list_txt_top txt_a_c">商家入驻</div>
            <div class="fotterDetail_list_txt_bot txt_a_c">优质房型 美好体验</div>
          </div>
        </div>
        <div class="txt_a_c">
          <div class="fotterDetail_list_1">
            <div class="fotterDetail_list_img">
              <img src="../../static/fotter_2.png" />
            </div>
            <div class="fotterDetail_list_txt_top txt_a_c">贴心服务</div>
            <div class="fotterDetail_list_txt_bot txt_a_c">快速处理 为您解忧</div>
          </div>
        </div>
        <div class="txt_a_c">
          <div class="fotterDetail_list_1">
            <div class="fotterDetail_list_img">
              <img src="../../static/fotter_3.png" />
            </div>
            <div class="fotterDetail_list_txt_top txt_a_c">实名认证</div>
            <div class="fotterDetail_list_txt_bot txt_a_c">实名认证 更放心</div>
          </div>
        </div>
        <div class="txt_a_r">
          <div class="fotterDetail_list_1">
            <div class="fotterDetail_list_img">
              <img src="../../static/fotter_4.png" />
            </div>
            <div class="fotterDetail_list_txt_top txt_a_c">安全无忧</div>
            <div class="fotterDetail_list_txt_bot txt_a_c">极速出票 安心随行</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 网站信息 -->
    <div class="website">
      <div class="websiteDetail">
        <!-- -->
        <div class="websiteDetailTop ovh">
          <div class="bottom_logo f_l">
            <img src="../../static/fotter_logo.png" />
          </div>
          <div class="bottomListAll f_l ovh">
            <div class="bottomList f_l">
              <div class="bottomList_tit">乐冰雪App下载</div>
              <div class="bottomList_img">
                <img src="../../static/app.png" />
              </div>
            </div>
            <div class="bottomList f_l">
              <div class="bottomList_tit">乐冰雪官方公众号</div>
              <div class="bottomList_img">
                <img src="../../static/gzh.png" />
              </div>
            </div>
            <div class="bottomList1 f_l">
              <div class="bottomList_tit">乐冰雪小程序</div>
              <div class="bottomList_img">
                <img src="../../static/xcx_code.jpg" />
              </div>
            </div>
          </div>
          <ul class="f_r" v-if="false">
            <li>联系我们</li>
            <li>投诉建议</li>
            <li>常见问题</li>
            <li>广告投放</li>
          </ul>
          <ul class="f_r m_r_160 m_t_15">
            <li v-if="false">关于我们</li>
            <li @click="seeAgreement(0)">用户服务协议</li>
            <li @click="seeAgreement(1)">隐私协议</li>
            <li v-if="false">帮助中</li>
          </ul>
        </div>
        <!-- -->
        <div class="txt_a_c websiteDetail_cont m_t_25 m_b_20">
          乐冰雪APP致力于打造体育运动及冰雪旅游智慧出行的用户优选平台。让您每次的滑雪出行，都在轻松、愉悦中尽享滑雪带来的极致畅快!
        </div>
        <div class="txt_a_c websiteDetail_cont">
          <!-- 官网地址：www.lexuetiyu.com  -->
          <span class="m_">邮箱：loveillbx@qq.com</span>
          <span class="m_">客服①：15101573502（微信同号）</span>
          <span class="m_">客服②：13031038283（微信同号）</span>
          <span class="">客服③：010-52480940</span>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <div class="copyright txt_a_c">Copyright © 2019-2020 Lexuetiyu.com 版权所有ICP证：冀IPC备19031674-1</div>
  </div>
</template>

<script>

  export default {
    name: 'fotter',
    data () {
      return {
        
      }
    },

    mounted() {
      this.getInfo();
    },

    computed:{
      
    },

    methods:{
      // 商家入驻
      business() {
        // 判断当前页面是不是要跳转的页面
        if (this.$route.path !== '/business') {
          this.$router.push({path: '/business' })
        }
      },

      // 点击协议
      seeAgreement(code) {
        var url = window.location.href;
        var index = url.lastIndexOf("\/");
        var str = url.substring(0, index + 1);
        localStorage.setItem('agreementCode', code)
        window.open(str + 'agreement');
      },

      getInfo() {
        console.log()
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="">
  @import "../components/css/component.css";

  .fotterAll {
    position: absolute;
    width: 100%;
    height: 520px;
    background: #fff;
    left: 0;
    bottom: 0;
    z-index: 1;
    cursor: pointer;
  }

  .fotterTop {
    min-width: 1200px;
    width: 100%;
    height: 180px;
    cursor: pointer;
    background-color: #EBF4FF;
  }

  .websiteDetailTop {
    margin-bottom: 45px;
    margin: 0 60px;
  }

  .fotterDetail {
    width: 1200px;
    margin: 0 auto;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  .fotterDetail > div {
    width: 25%;
  }

  .fotterDetail_list {
    
  }

  .fotterDetail_list_img {
    width: 34px;
    height: 38px;
    margin: 0 auto;
  }

  .fotterDetail_list_1 {
    width: 126px;
    height: 80px;
    margin: 0 auto;
    margin-top: 50px !important;
  }

  .fotterDetail_list_txt_top {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #434444;
    line-height: 24px;
  }

  .fotterDetail_list_txt_bot {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #8C8C8C;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .website {
    min-width: 1200px;
    height: 300px;
  }

  .bottom_logo {
    height: 116px;
    width: 300px;
    margin-top: -15px;
  }

  li{
    font-size: 14px;
    color: #434444;
    margin-bottom: 10px;
  }

  .bottomListAll{
    margin-left: 100px;
  }

  .bottomList{
    width: 115px;
    margin-right: 30px;
  }

  .bottomList1{
     width: 95px;
  }

  .bottomList_tit {
    text-align: center;
    border-left: 2px solid #0F7EFF;
    height: 14px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1C1C1C;
    line-height: 14px;
  }

  .bottomList_img {
    width: 60px;
    height: 60px;
    margin: 10px auto;
  }

  .websiteDetail {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
  }

  .websiteDetail_cont {
    font-size: 14px;
    color: #434444;
    letter-spacing: 1px;
  }

  .m_ {
    margin-right: 60px;
  }

  .copyright {
    min-width: 1200px;
    height: 40px;
    line-height: 40px;
    color: #BFC0C0;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    letter-spacing: 1px;
    background-color: #434444;
  }

</style>



// WEBPACK FOOTER //
// src/components/fotter.vue